import './index.scss';
import { FlexColumn, FlexRow } from 'src/style';
import ImageFallback from "src/assets/img/image-fallback.png";
import { useWindowScroll } from 'src/hooks/useWindowScroll';
import { HeaderProps } from '../types';

export const Header = ({ user, children, className }: HeaderProps) => {
    const { scrollHeight } = useWindowScroll();

    return (
        <div className='header-container'>
            <FlexRow gap='2' topMargin='6.4' className='header-flex-wrapper'>
                <FlexColumn
                    alignItems='start'
                    className={`flex-children ${className}`}
                >
                    {children}
                </FlexColumn>

                <FlexRow
                    width='30'
                    sizeUnit='%'
                    justifyContent='end'
                    className={`flex-user-details ${scrollHeight > 15 ? 'scroll-bg' : ''}`}
                >
                    <FlexColumn className='text-container' alignItems='end'>
                        <p className='header-text'>{user?.profile?.username}</p>
                        <p className='header-text'>{user?.profile?.memberType}</p>
                    </FlexColumn>
                    <div className='user-avatar-wraper'>
                        <img className='user-avatar' src={user?.profile?.avatar ?? ImageFallback} alt='user avatar' />
                    </div>
                </FlexRow>
            </FlexRow>
        </div>
    )
}
